import type { WidgetContract, WidgetRegistry } from './types';

/**
 * Create a fresh, page-scoped widget registry. Each page constructs its
 * own instance so Trading widgets and Market Monitor widgets never appear
 * in each other's pickers.
 */
export function createWidgetRegistry(): WidgetRegistry {
  const map = new Map<string, WidgetContract>();
  return {
    register(contract) {
      map.set(contract.widgetType, contract);
    },
    get(widgetType) {
      return map.get(widgetType);
    },
    getAll() {
      return Array.from(map.values());
    },
  };
}
